// frontend/src/components/PixCobrancaTabs.js
//
// Gerar Cobrança › Pix Santander (ETAPA 6c): o seletor "Plano (recorrência)" | "Atendimento (Pix único)". As duas telas ficam
// montadas (a inativa só fica escondida), para não perder o que a pessoa já preencheu ao trocar de aba.

import React, { useState } from 'react';
import PixCobranca from './PixCobranca';
import PixAvulsa from './PixAvulsa';
import './PixCobrancaTabs.css';

export default function PixCobrancaTabs(props) {
  const [mode, setMode] = useState('plano');
  return (
    <div className="pixt-raiz">
      <div className="pixt" role="tablist" aria-label="Tipo de cobrança Pix">
        <button type="button" role="tab" aria-selected={mode === 'plano'} className={`pixt-aba ${mode === 'plano' ? 'pixt-ativa' : ''}`} onClick={() => setMode('plano')}>Plano (recorrência)</button>
        <button type="button" role="tab" aria-selected={mode === 'atendimento'} className={`pixt-aba ${mode === 'atendimento' ? 'pixt-ativa' : ''}`} onClick={() => setMode('atendimento')}>Atendimento (Pix único)</button>
      </div>
      <div role="tabpanel" hidden={mode !== 'plano'}><PixCobranca {...props} /></div>
      <div role="tabpanel" hidden={mode !== 'atendimento'}><PixAvulsa apiFetch={props.apiFetch} initialClient={props.initialClient} /></div>
    </div>
  );
}
